import { render, staticRenderFns } from "./TeamRequestsDetailPage.vue?vue&type=template&id=44835c00"
import script from "./TeamRequestsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsDetailPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44835c00')) {
      api.createRecord('44835c00', component.options)
    } else {
      api.reload('44835c00', component.options)
    }
    module.hot.accept("./TeamRequestsDetailPage.vue?vue&type=template&id=44835c00", function () {
      api.rerender('44835c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/team-requests-detail/TeamRequestsDetailPage.vue"
export default component.exports